import './cursor.css'

function Cursor()
{
    return <div className='cursor' id="cursor"></div>
}

export default Cursor;